<template>
    <OrderForm :url="url" :model="model" :errors="errors" v-on:save="saveOrder"></OrderForm>
</template>

<script>
import OrderForm from './OrderForm'
export default {
  name: 'OrderCreate',
  components: {OrderForm},
  props: ['url'],
  data () {
    return {
      model: {},
      errors: {}
    }
  },
  methods: {
    saveOrder () {
      let self = this

      this.$http
        .post(this.url + `/create`, this.model, {
          'headers': {
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'language': this.$store.state.loading.language
          }
        }).then(res => {
          if (res.data && res.data.data !== 'undefined') {
            self.model = res.data.data
            this.$router.push('/admin/orders/index')
          } else {
            this.errors = res.response.data.errors
          }
        }).catch(res => {

        })
    }
  },
  created: function () {
    this.$emit('updateTitle', this.$translate.t('Order Create'))

    let self = this
    this.$http
      .get(this.url + `/show/0`, {
        'headers': {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
          'language': this.$store.state.loading.language
        }
      }).then(res => {
        self.model = res.data.data
      }).catch(res => {

      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/order/OrderCreate.vue